import React from "react";
import alyseiIcon from "../../../assets/landing-page/alysei-icon-only.png";

const TypingIndicator = () => (
  <div className="flex items-end gap-3 justify-start animate-fadeIn">
    {/* Avatar */}
    <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center flex-shrink-0 overflow-hidden shadow">
      <img src={alyseiIcon} alt="Alysei AI" className="w-5 h-5 object-contain" />
    </div>

    {/* Bubble */}
    <div className="bg-white border border-gray-100 shadow-sm rounded-2xl rounded-bl-sm px-4 py-3 flex items-center gap-1.5">
      <span
        className="w-2 h-2 rounded-full inline-block"
        style={{ backgroundColor: "#14b8a6", animation: "typing-bounce 1.2s ease-in-out infinite", animationDelay: "0ms" }}
      />
      <span
        className="w-2 h-2 rounded-full inline-block"
        style={{ backgroundColor: "#14b8a6", animation: "typing-bounce 1.2s ease-in-out infinite", animationDelay: "200ms" }}
      />
      <span
        className="w-2 h-2 rounded-full inline-block"
        style={{ backgroundColor: "#14b8a6", animation: "typing-bounce 1.2s ease-in-out infinite", animationDelay: "400ms" }}
      />
    </div>
  </div>
);

export default TypingIndicator;
